let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4oq8D")).then(() => parcelRequire('lE3ki'));